import { create } from 'zustand';

interface AgentflowDocState {
  mdByFlowId: Record<string, string | null>;
  isLoading: boolean;
  isSaving: boolean;
  isRegenerating: boolean;
  error: string | null;
  setMd: (flowId: string, md: string | null) => void;
  setLoading: (isLoading: boolean) => void;
  setSaving: (isSaving: boolean) => void;
  setRegenerating: (isRegenerating: boolean) => void;
  setError: (error: string | null) => void;
  clearTransient: () => void;
}

export const useAgentflowDocStore = create<AgentflowDocState>(set => ({
  mdByFlowId: {},
  isLoading: false,
  isSaving: false,
  isRegenerating: false,
  error: null,
  setMd: (flowId, md) =>
    set(state => ({
      mdByFlowId: { ...state.mdByFlowId, [flowId]: md },
    })),
  setLoading: isLoading => set({ isLoading }),
  setSaving: isSaving => set({ isSaving }),
  setRegenerating: isRegenerating => set({ isRegenerating }),
  setError: error => set({ error }),
  clearTransient: () =>
    set({
      isLoading: false,
      isSaving: false,
      isRegenerating: false,
      error: null,
    }),
}));
